import React from 'react';

const DeactivateIcon = () => {
  return (
    <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="11.8999" cy="12.7072" r="9.5" stroke="#333333" strokeWidth="1.6" strokeLinecap="round"/>
        <path d="M9.01598 9.68172L14.984 15.6497" stroke="#333333" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M14.984 9.68172L9.01604 15.6497" stroke="#333333" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  )
}

export default DeactivateIcon;